var map = {
	"./PhotoProfile.jpeg": 277,
	"./project1.png": 695,
	"./project2.png": 420,
	"./project3.png": 661,
	"./project4.png": 682,
	"./project5.png": 227,
	"./project6.png": 16,
	"./project7.png": 217,
	"./project8.png": 462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 299;